import type { ComponentType, SVGProps } from 'react';
import {
  HomeIcon, BoxIcon, LayersIcon, LinkGapIcon,
  ReceiptIcon, UsersIcon, SyncIcon, ClipboardIcon, SlidersIcon,
} from '../icons/Icons';

type IconC = ComponentType<SVGProps<SVGSVGElement>>;
export type Badge = { label: string; tone: 'new' | 'pro' | 'free' };

export interface NavItem {
  label: string;
  to?: string;
  icon?: IconC;
  badge?: Badge;
  end?: boolean;
  children?: NavItem[];
}

export interface NavSection {
  title?: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    items: [
      { label: 'Dashboard', to: '/', icon: HomeIcon, end: true, badge: { label: 'NEW', tone: 'new' } },
    ],
  },
  {
    title: 'Operations',
    items: [
      {
        label: 'Catalog',
        icon: BoxIcon,
        children: [
          { label: 'Products', to: '/products' },
          { label: 'Listing Gaps', to: '/listing-gaps' },
          { label: 'Channel clicks', to: '/channel-clicks' },
        ],
      },
      { label: 'Inventory', to: '/inventory', icon: LayersIcon },
      { label: 'Purchase Orders', to: '/purchase-orders', icon: ReceiptIcon },
      { label: 'Fulfilment', to: '/fulfilment', icon: BoxIcon },
      { label: 'Dealers', to: '/dealers', icon: UsersIcon },
      { label: 'Reps', to: '/reps', icon: UsersIcon },
      { label: 'Leads', to: '/leads', icon: UsersIcon },
    ],
  },
  {
    title: 'Customers',
    items: [
      { label: 'Claims', to: '/claims', icon: ClipboardIcon },
      { label: 'Privacy requests', to: '/privacy-requests', icon: ClipboardIcon },
      { label: 'Cancellations', to: '/cancellations', icon: ReceiptIcon },
      { label: 'Resale certificates', to: '/resale-certificates', icon: ClipboardIcon },
    ],
  },
  {
    title: 'System',
    items: [
      { label: 'Backfill / Sync', to: '/backfill', icon: SyncIcon, badge: { label: 'LIVE', tone: 'free' } },
      { label: 'Audit', to: '/audit', icon: ClipboardIcon },
      { label: 'Config', to: '/config', icon: SlidersIcon },
      { label: 'Settings', to: '/settings', icon: SlidersIcon },
    ],
  },
];

// Flat path -> breadcrumb label map for the header trail.
export const PATH_LABELS: Record<string, string> = {
  '': 'Dashboard',
  'products': 'Products',
  'inventory': 'Inventory',
  'listing-gaps': 'Listing Gaps',
  'channel-clicks': 'Channel clicks',
  'purchase-orders': 'Purchase Orders',
  'fulfilment': 'Fulfilment',
  'dealers': 'Dealers',
  'reps': 'Reps',
  'claims': 'Claims',
  'privacy-requests': 'Privacy requests',
  'cancellations': 'Cancellations',
  'resale-certificates': 'Resale certificates',
  'backfill': 'Backfill / Sync',
  'audit': 'Audit',
  'config': 'Config',
  'settings': 'Settings',
  'account': 'Your account',
  'login': 'Login',
};

export const LinkGap = LinkGapIcon; // re-export for any listing-gap UI use
